// extracted by mini-css-extract-plugin
module.exports = {"container":"A7qKriGaoA26WYDJuruc-","cancelBtn":"_1ItRTm3sHRwyu5subiZ35o","icon":"_3avo95W1_h1pxSOayygKFA","saveBtn":"_3pKRILu4SC-acwxMu3BsmY"};